(() => {
  const q = (s, root = document) => root.querySelector(s);
  const qa = (s, root = document) => [...root.querySelectorAll(s)];
  const announce = text => { const el=q('#LiveStatus'); if(el) el.textContent=text; };
  let lastOpener;
  function openDialog(id, opener) {
    const dialog=document.getElementById(id);
    if(!dialog) return;
    qa('dialog[open]').forEach(d=>d.close());
    lastOpener=opener || document.activeElement;
    if(!dialog.open) dialog.showModal();
  }
  document.addEventListener('click', event => {
    const open=event.target.closest('[data-open]');
    if(open){event.preventDefault();openDialog(open.dataset.open,open);}
    const close=event.target.closest('[data-close]');
    if(close) close.closest('dialog')?.close();
    const cart=event.target.closest('[data-cart-open]');
    if(cart && q('#CartDialog')){event.preventDefault();openDialog('CartDialog',cart);}
    if(event.target.tagName==='DIALOG'){
      const r=event.target.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();
    }
    qa('.mega[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;});
  });
  document.addEventListener('close',()=>lastOpener?.focus({preventScroll:true}),true);
  document.addEventListener('keydown',event=>{if(event.key==='Escape')qa('.mega[open]').forEach(d=>d.open=false);});
  function renderAddedSections(sections, sectionId) {
    const html=sections?.[sectionId];if(!html)return false;
    const parsed=new DOMParser().parseFromString(html,'text/html');
    const initial=q('[data-cart-initial]',parsed);if(!initial)return false;
    const metadata=q('[data-cart-item-meta]',parsed);
    window.renderCartDrawer(JSON.parse(initial.textContent),metadata?JSON.parse(metadata.textContent):{});
    return true;
  }
  async function refreshCart() {
    const response=await fetch(`${window.themeRoutes.cart}.js`,{headers:{Accept:'application/json'}});
    if(!response.ok)throw Error('Your bag could not refresh.');
    window.renderCartDrawer?.(await response.json());
  }
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-product-form]');
    if(!form || !window.fetch || !q('#CartDialog'))return;
    if(event.submitter?.closest('.shopify-payment-button,.product-payment'))return;
    event.preventDefault();
    const button=event.submitter || q('[data-add-button]',form),error=q('[data-form-error]',form);
    const drawer=q('#CartDialog');
    if(button.disabled||form.dataset.submitting==='true'||drawer.dataset.addPending==='true')return;
    form.dataset.submitting='true';form.setAttribute('aria-busy','true');button.setAttribute('aria-disabled','true');error.textContent='';
    const content=q('[data-cart-content]',drawer),previousHTML=content.innerHTML,wasEmpty=drawer.classList.contains('is-empty');
    const footer=q('.cart-fixed-footer',drawer);content.inert=true;if(footer)footer.inert=true;drawer.dataset.addPending='true';
    // Show the chosen item while Shopify confirms it; checkout stays locked until confirmed.
    const pending=document.createElement('article');pending.className='cart-drawer-line';pending.setAttribute('aria-busy','true');
    const image=document.createElement('img');image.alt='';image.src=form.dataset.pendingImage||q('[data-product-section] img')?.currentSrc||'';
    const imageBox=document.createElement('div');if(image.getAttribute('src')){image.style.cssText='width:100%;aspect-ratio:1;object-fit:contain';imageBox.append(image);}pending.append(imageBox);
    const info=document.createElement('div');info.className='cart-item-info';
    const title=document.createElement('span');title.className='cart-item-title';title.textContent=form.dataset.pendingTitle||q('[data-product-section] h1')?.textContent||'Selected item';info.append(title);
    for(const selector of ['.size-option-price','.size-option-label']){const source=q(selector,button);if(source){const line=document.createElement('p');line.textContent=source.textContent;info.append(line);}}
    pending.append(info);content.querySelector('.empty-state')?.remove();content.append(pending);drawer.classList.remove('is-empty');
    const notice=document.createElement('p');notice.className='cart-add-status sr-only';notice.setAttribute('role','status');notice.textContent='Adding selected item';content.before(notice);
    openDialog('CartDialog',button);
    let added=false;document.dispatchEvent(new CustomEvent('studio:cart-mutating'));
    try{
      const data=new FormData(form),sectionId=drawer.dataset.cartSection||'cart-panel';data.set('sections',sectionId);data.set('sections_url',location.pathname);
      const response=await fetch(window.themeRoutes.add,{method:'POST',body:data,headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok)throw Error(result.description || result.message || 'Unable to add this item. Please try again.');
      added=true;document.dispatchEvent(new CustomEvent('product:added',{detail:{variantId:new FormData(form).get('id')}}));
      if(!renderAddedSections(result.sections,sectionId))await refreshCart();
      announce('Item added to your bag.');notice.remove();
    }catch(err){
      error.textContent=added?'Item added. Your bag could not refresh. Use the bag link to review it.':err.message;
      if(added){const link=document.createElement('a');link.href=window.themeRoutes.cart;link.textContent=' View bag';link.style.textDecoration='underline';error.append(link);}
      content.innerHTML=previousHTML;drawer.classList.toggle('is-empty',wasEmpty);notice.classList.remove('sr-only');notice.textContent=error.textContent;notice.setAttribute('role','alert');
      if(added){const link=document.createElement('a');link.href=window.themeRoutes.cart;link.textContent=' View bag';notice.append(link);}
      announce(error.textContent);
    }finally{pending.remove();content.inert=false;if(footer)footer.inert=false;delete drawer.dataset.addPending;delete form.dataset.submitting;form.removeAttribute('aria-busy');button.removeAttribute('aria-disabled');document.dispatchEvent(new CustomEvent('studio:cart-mutated'));}
  });
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-variant-select]'))return;
    const section=event.target.closest('[data-product-section]');
    const variants=JSON.parse(q('[data-variants]',section).textContent);
    const variant=variants.find(v=>String(v.id)===event.target.value);
    if(!variant)return;
    qa('[data-product-price]').forEach(target=>{
      const price=document.createElement('span');price.className='price';
      if(variant.comparePrice){
        const label=document.createElement('span');label.className='sr-only';label.textContent='Original price';
        const old=document.createElement('s');old.className='muted';old.textContent=variant.comparePrice;
        const saleLabel=document.createElement('span');saleLabel.className='sr-only';saleLabel.textContent='Sale price';
        price.append(label,old,document.createTextNode(' '),saleLabel);
      }
      const current=document.createElement('span');current.className='price-current';current.textContent=variant.price;
      price.append(current);target.replaceChildren(price);
    });
    const button=q('[data-add-button]',section);button.disabled=!variant.available;button.innerHTML=variant.available?'ADD TO BAG <span>+</span>':'SOLD OUT';
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    if(variant.mediaId){
      const image=document.getElementById(`Media-${variant.mediaId}`),gallery=q('.product-gallery',section);
      // Change the gallery photo horizontally without moving the product page.
      if(image&&gallery&&gallery.scrollWidth>gallery.clientWidth){
        const left=gallery.scrollLeft+image.getBoundingClientRect().left-gallery.getBoundingClientRect().left;
        gallery.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
  });
  const sliders=new Map();
  function initialize(root=document){
    qa('[data-slideshow]',root).forEach(el=>{
      if(sliders.has(el))return;
      const slides=qa('[data-slide]',el),dots=qa('[data-slide-go]',el);
      if(slides.length<2)return;
      let current=0,timer,paused=el.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pauseButton=q('[data-slide-pause]',el);
      function show(index){current=(index+slides.length)%slides.length;slides.forEach((s,i)=>{s.classList.toggle('is-active',i===current);s.style.transform=`translateX(${(i-current)*100}%)`;s.inert=i!==current;s.setAttribute('aria-hidden',String(i!==current));});dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===current)));}
      function stop(){clearInterval(timer);}
      function start(){stop();if(!paused&&!document.hidden)timer=setInterval(()=>show(current+1),Number(el.dataset.interval)||7000);}
      function pauseUI(){pauseButton.textContent=paused?'â–¶':'â…¡';pauseButton.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');}
      q('[data-slide-prev]',el)?.addEventListener('click',()=>{show(current-1);start();});
      q('[data-slide-next]',el)?.addEventListener('click',()=>{show(current+1);start();});
      dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.slideGo));start();}));
      pauseButton.addEventListener('click',()=>{paused=!paused;pauseUI();start();});
      el.addEventListener('mouseenter',stop);el.addEventListener('mouseleave',start);
      el.addEventListener('focusin',stop);el.addEventListener('focusout',event=>{if(!el.contains(event.relatedTarget))start();});
      const visibility=()=>document.hidden?stop():start();document.addEventListener('visibilitychange',visibility);
      let startX=0;el.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;},{passive:true});
      el.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)>60){show(current+(delta<0?1:-1));start();}},{passive:true});
      sliders.set(el,{show,stop,destroy:()=>{stop();document.removeEventListener('visibilitychange',visibility);}});pauseUI();start();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>sliders.forEach((api,el)=>{if(event.target.contains(el)){api.destroy();sliders.delete(el);}}));
  document.addEventListener('shopify:block:select',event=>{
    const el=event.target.closest('[data-slideshow]');const api=sliders.get(el);
    if(api){api.stop();const index=qa('[data-slide]',el).indexOf(event.target.closest('[data-slide]'));if(index>=0)api.show(index);}
  });
})();
